import React, { SVGProps } from 'react';
import styled from '@emotion/styled';

import { Notice } from '../services/useSellerNotice';
import { DefaultNotice } from './DefaultNotice';
import { VacationNotice } from './VacationNotice';

interface SellerNoticeProps {
  notice: Notice;
  headerTitle: string;
  isImageType: boolean;
  notice_type: string;
  titleDate?: string;
  date?: string;
  noticeIcon: ({ width, height, color, ...props }: SVGProps<SVGSVGElement>) => JSX.Element;
}

export const SellerNotice: React.FC<SellerNoticeProps> = ({
  notice,
  headerTitle,
  isImageType,
  notice_type,
  titleDate,
  date,
  noticeIcon,
}) => {
  // 이미지 타입 공지
  if (isImageType) {
    return (
      <ImageContainer>
        <NoticeImage src={notice.imageUrl} alt='셀러 공지 이미지' />
      </ImageContainer>
    );
  }

  // 휴가 공지
  if (notice_type === 'VACATION') {
    return <VacationNotice notice={notice} titleDate={titleDate} date={date} />;
  }

  // 일반/배송 공지
  return <DefaultNotice notice={notice} headerTitle={headerTitle} NoticeIcon={noticeIcon} />;
};

const ImageContainer = styled.div`
  padding: 24px 16px;
  position: relative;
`;

const NoticeImage = styled.img`
  width: 100%;
  height: auto;
`;
